import React from "react";
import { useEffect, useState } from "react";
import DashboardCard from "../../../components/DashboardCard";
import MyFiles from "../../../assets/images/MyFiles.svg";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { TicketIcon } from "@heroicons/react/24/solid";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useGetScoreCardCount } from "../../CarrierAgreementMgmt/ScoreCard/hooks/useGetScoreCardCount";

const NewScorecardsCard = () => {
  const [caCount, setCACount] = useState("...");
  const modulePermission = PERMISSIONS.permission_scorecard_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  const useraccount = useRecoilValue(accountAtom);

  const history = useHistory();
  const [connection, setConnection] = useState<any>(null);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const { data: scoreCard } = useGetScoreCardCount();

  const scoreCardCount = scoreCard?.data?.result.map((x) => x.scorecardsCount);

  return (
    <div
      className="p-2 pr-4 bg-white text-primary rounded-lg animate-fade-in-down2 shadow-md hover:text-white hover:bg-tertiary"
      onClick={() => {
        if (userPermissions.includes(modulePermission)) {
          const urlPath = "/employeetab/scorecards";
          history.push({
            pathname: urlPath,
          });
        }
      }}
    >
      <DashboardCard
        text="Scorecards"
        count={scoreCardCount}
        image={
          <TicketIcon className="text-white bg-tertiary rounded-md h-7 w-7 p-1" />
        }
        hasAccess={userPermissions.includes(modulePermission)}
      />
    </div>
  );
};

export default NewScorecardsCard;
